module.exports = __webpack_public_path__ + "img/will.072e346d.svg";